var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIbisvisionLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.8438 80.5H47.5813L79.7813 7.76245H99.1875L66.8438 80.5Z",
    fill: "#25BECB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8438 80.5H47.5813L79.7813 7.76245H99.1875L66.8438 80.5Z",
    fill: "url(#paint0_linear_21_619)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8437 80.5L59.0812 54.625L57.2125 58.65L66.8437 80.5Z",
    fill: "url(#paint1_linear_21_619)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4375 36.3687H28.175L47.5812 80.4999H66.8438L47.4375 36.3687Z",
    fill: "#49BC99"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4375 36.3687H28.175L47.5812 80.4999H66.8438L47.4375 36.3687Z",
    fill: "url(#paint2_linear_21_619)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0937 107.094H12.9375V97.6062H15.2375V107.094H15.0937Z",
    fill: "#49BC99"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8813 104.362C26.8813 105.944 25.875 107.094 23.2875 107.094H18.6875V97.6062H22.8562C25.5875 97.6062 26.45 98.7562 26.45 100.194C26.45 101.2 25.7312 101.919 25.5875 102.062C26.45 102.494 26.8813 103.356 26.8813 104.362ZM24.15 100.481C24.15 99.9062 23.7187 99.4749 22.8562 99.4749H20.8437V101.487H22.8562C23.8625 101.487 24.15 101.2 24.15 100.481ZM23 103.212H20.8437V105.081H23C23.8625 105.081 24.4375 104.794 24.4375 104.219C24.4375 103.5 24.0062 103.212 23 103.212Z",
    fill: "#49BC99"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2 107.094H29.9V97.6062H32.2V107.094Z",
    fill: "#49BC99"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9812 100.625H40.6812C40.6812 100.194 40.1063 99.475 39.1 99.475C38.3813 99.475 37.5188 99.7625 37.5188 100.337C37.5188 100.769 38.0938 100.912 39.5312 101.344C40.9688 101.775 43.125 102.206 43.125 104.362C43.125 106.231 41.5437 107.237 39.3875 107.237C36.3687 107.237 35.2188 105.225 35.2188 103.787H37.5188C37.5188 103.787 37.6625 105.225 39.5312 105.225C40.5375 105.225 40.9688 104.794 40.9688 104.362C40.9688 103.787 40.1062 103.5 39.2437 103.356C37.8062 103.069 35.3625 102.494 35.3625 100.337C35.3625 98.6125 37.0875 97.3187 39.2437 97.3187C41.6875 97.4625 42.9812 99.0437 42.9812 100.625Z",
    fill: "#49BC99"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4625 107.094H49.0188L44.85 97.6062H47.4375L50.3125 104.362L53.1875 97.6062H55.775L51.4625 107.094Z",
    fill: "#25BECB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8063 107.094H58.5063V97.6062H60.8063V107.094Z",
    fill: "#25BECB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7313 100.625H69.4312C69.4312 100.194 68.8563 99.475 67.85 99.475C67.1313 99.475 66.2687 99.7625 66.2687 100.337C66.2687 100.769 66.8438 100.912 68.2812 101.344C69.7188 101.775 71.875 102.206 71.875 104.362C71.875 106.231 70.2938 107.237 68.1375 107.237C65.1188 107.237 63.9688 105.225 63.9688 103.787H66.2687C66.2687 103.787 66.4125 105.225 68.2812 105.225C69.2875 105.225 69.7188 104.794 69.7188 104.362C69.7188 103.787 68.8562 103.5 67.9937 103.356C66.5562 103.069 64.1125 102.494 64.1125 100.337C64.1125 98.6125 65.8375 97.3187 67.9937 97.3187C70.4375 97.4625 71.7313 99.0437 71.7313 100.625Z",
    fill: "#25BECB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3375 107.094H75.0375V97.6062H77.3375V107.094Z",
    fill: "#25BECB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9875 102.35C89.9875 105.081 87.8312 107.238 85.1 107.238C82.3687 107.238 80.2125 105.081 80.2125 102.35C80.2125 99.6188 82.3687 97.4625 85.1 97.4625C87.8312 97.4625 89.9875 99.6188 89.9875 102.35ZM82.225 102.35C82.225 103.931 83.5187 105.081 84.9562 105.081C86.5375 105.081 87.6875 103.788 87.6875 102.35C87.6875 100.769 86.3937 99.6188 84.9562 99.6188C83.5187 99.475 82.225 100.769 82.225 102.35Z",
    fill: "#25BECB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102.062 107.094H99.7625L95.0187 101.344V107.094H92.7188V97.6062H95.0187L99.7625 103.356V97.6062H102.062V107.094Z",
    fill: "#25BECB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_619",
    x1: 56.1873,
    y1: 80.2242,
    x2: 90.1072,
    y2: 8.70603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25BECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25BECB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_619",
    x1: 57.2526,
    y1: 67.5096,
    x2: 66.8481,
    y2: 67.5096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25BECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25BECB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21_619",
    x1: 56.2646,
    y1: 79.1057,
    x2: 37.8742,
    y2: 35.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49BC99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49BC99",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbisvisionLogo);
export default __webpack_public_path__ + "static/media/ibisvision-logo.c87308093bc9493ea3ea6bf26ab16c7a.svg";
export { ForwardRef as ReactComponent };